import { captureException } from '@sentry/react';
import { oneflow } from 'javascript-1flow-sdk';

import { appConfig } from '#/shared/config/AppConfig';

export const initializeOneFlow = () => {
  const apiKey = appConfig.oneFlow.projectKey;

  if (!apiKey) {
    captureException('1Flow API key not found');
  } else {
    try {
      oneflow.oneFlowInit(apiKey);
    } catch (error) {
      captureException('Failed to initialize 1Flow SDK', {
        originalException: error,
      });
    }
  }
};

/**
 * Log an event in 1Flow, that can be used to trigger a survey.
 * @param eventName - The name of the event to track.
 * @param properties - The properties to track with the event.
 */
export const logEvent = (eventName: string, properties?: Record<string, unknown>) => {
  try {
    oneflow.logEvent(eventName, properties);
  } catch (error) {
    captureException('Failed to track 1Flow event', {
      originalException: error,
    });
  }
};

export const triggerTimesheetApprovalSurvey = (timesheetId: string) => {
  logEvent('timesheet_approval_survey', {
    timesheetId,
  });
};
